import { render } from "./index.vue?vue&type=template&id=71eb31ee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=71eb31ee&lang=css"

import exportComponent from "L:\\vuexiangmu\\oppt2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__